import { Component, Prop, Vue } from 'vue-property-decorator';
import lodash from 'lodash';
import { REWARD_REQUEST_STATUSES } from '@/constants';
import { ActionMenuItem, DisplayStatus, RewardRequestDTO } from '@/models';

@Component
export default class StatusButtons extends Vue {
  @Prop() updateStatusItem: RewardRequestDTO;

  private actions: ActionMenuItem[] = [
    {
      label: 'Process',
      icon: 'mdi-cart-outline',
      color: '#17A2B8',
      handler: () => this.openInProgressDialog()
    },
    {
      label: 'Approve',
      icon: 'mdi-checkbox-marked-circle-outline',
      color: '#17A2B8',
      handler: () => this.onApproveClick()
    },
    { label: 'Reject', icon: 'mdi-delete', color: '#F24822', handler: () => this.onRejectClick() }
  ];

  get displayLabel(): string {
    return lodash.replace(this.updateStatusItem.status, new RegExp('_', 'g'), ' ');
  }

  get status(): DisplayStatus {
    return REWARD_REQUEST_STATUSES[this.updateStatusItem.status];
  }

  get toggleShown(): boolean {
    return (
      this.updateStatusItem.status !== REWARD_REQUEST_STATUSES.REJECTED.label &&
      this.updateStatusItem.status !== REWARD_REQUEST_STATUSES.APPROVED.label &&
      this.updateStatusItem.status !== REWARD_REQUEST_STATUSES.APPROVED_WITH_REFUND.label
    );
  }

  isProcessDisabled(item: ActionMenuItem): boolean {
    return (
      (this.updateStatusItem.status === REWARD_REQUEST_STATUSES.IN_PROGRESS.label ||
        this.updateStatusItem.status === REWARD_REQUEST_STATUSES.USER_APPROVED.label) &&
      item.label === 'Process'
    );
  }

  getActionItemColor(actionItem: ActionMenuItem): string | undefined {
    return this.isProcessDisabled(actionItem) ? 'grey lighten-5' : actionItem.color;
  }

  onApproveClick(): void {
    this.$emit('onApproveClick');
  }

  onRejectClick(): void {
    this.$emit('onRejectClick');
  }

  openInProgressDialog(): void {
    this.$emit('openInProgressDialog');
  }
}
